<template>
  <div class="d-flex align-center">
    <img :src="imgPath" class="mr-2 rounded-circle" width="60" height="60" @click.stop="showFull" />
    <div>{{ data.name }}</div>
  </div>
</template>

<script>
import ImageViewer from "@/components/Image-viewer/ImageViewer.vue";

export default {
  name: "Employee",

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    // get initials from full name
    initials() {
      return this.data.name
        .split(" ")
        .map(name => name[0])
        .join(".");
    },

    imgPath() {
      if (this.data.avatar) {
        return this.data.avatar.path;
      }

      return `https://placehold.co/60x60?text=${this.initials}`;
    },
  },

  methods: {
    showFull() {
      this.$dialog.show(ImageViewer, {
        src: this.imgPath,
        width: 600,
      });
    },
  },
};
</script>
